import {swiper, swiperSlide} from 'vue-awesome-swiper';

export default {
	components: {
		swiper,
		swiperSlide
	},
	data() {
		return {
			notNextTick: true,
			sld04SliderOption: {
				autoplay: {
					delay: this.duration,
					stopOnLastSlide: false,
					disableOnInteraction: true
				},
				loop: false,
				mousewheelControl: true,
				slidesPerView: 'auto',
				simulateTouch: false,
				navigation: {
					nextEl: this.nextButton || null,
					prevEl: this.prevButton || null
				},
				spaceBetween: 49,
				breakpoints: {
					479: {
						spaceBetween: 0,
						slidesPerView: 2
					},
					1439: {
						slidesPerView: 3
					}
				},
				mousewheel: false
			},
			isMoreElementsThanFit: false
		};
	},
	props: {
		moduleId: {
			type: String,
			required: true
		},
		nextButton:{
			type: String,
			required: true
		},
		prevButton: {
			type: String,
			required: true
		},
		duration: {
			type: Number,
			required: true
		}
	},
	mounted() {
		let container = document.querySelector(`.sld04-logo-slider.${this.moduleId} .swiper-container`);
		let slides = Array.from(document.querySelectorAll(`.sld04-logo-slider.${this.moduleId} .swiper-slide`));
		let containerWidth = container.offsetWidth;
		let slidesWidth = slides.reduce((sum, slide) => sum + slide.offsetWidth, 0);

		this.isMoreElementsThanFit = containerWidth < slidesWidth;
		this.sld04SliderOption.loop = this.isMoreElementsThanFit;
		this.sld04SliderOption.simulateTouch = this.isMoreElementsThanFit;
	}
};



// WEBPACK FOOTER //
// ../source/modules/SLD04-logo-slider/SLD04-logo-slider.js